import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompressorAndSilencers = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 90,
	height: 80.56,
	viewBox: "0 0 90.0 80.56",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 39.0 74.56 L 35.0 80.56 L 55.0 80.56 L 51.0 74.56 M 20.0 5.56 L 20.0 70.56 A 9.0 5.0 0.0 0 1 0.0 70.56 L 0.0 5.56 A 9.0 5.0 0.0 0 1 20.0 5.56 Z M 70.0 5.56 L 70.0 70.56 A 9.0 5.0 0.0 0 0 90.0 70.56 L 90.0 5.56 A 9.0 5.0 0.0 0 0 70.0 5.56 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 55.0 35.56 L 55.0 70.56 A 9.0 5.0 0.0 0 1 35.0 70.56 L 35.0 35.56 A 9.0 5.0 0.0 0 1 55.0 35.56 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 45,
			cy: 43.56,
			rx: 8,
			ry: 8,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 45,
			cy: 63.56,
			rx: 8,
			ry: 8,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 0,
			height: 0,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 20.0 53.56 L 35.0 53.56 M 55.0 53.56 L 70.0 53.56",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 27.5 45.56 L 27.5 61.56 M 62.5 45.56 L 62.5 61.56",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgCompressorAndSilencers;
